var map = {
	"./curve-1.svg": 9782,
	"./curve-form-1.svg": 6632,
	"./curve-form-2.svg": 8864,
	"./elements.png": 9650,
	"./form-mail.svg": 3646,
	"./form-name.svg": 5053,
	"./form-phone.svg": 9020,
	"./form-send.svg": 5048,
	"./form-text.svg": 9401
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7017;